<template>
  <div
    :class="[
      $style.gridLayout,
      { 'bg-background-dark': active }
    ]"
    :title="linkTitle"
    class="overflow-hidden p-4 relative transition cursor-pointer border-2
      border-transparent focus:border-brand-dark hover:border-brand grid gapy-2 gapx-4"
    style="--transition-properties: border;"
    tabindex="0"
    @click="selectVideo"
  >
    <img
      :class="$style.itemThumbnail"
      :src="thumbnailUrl"
      class="h-16 w-16 obj-cover rounded"
    >
    <h1 class="text-lg text-justify m-0">
      <a
        :href="linkUrl"
        :target="linkTarget(linkUrl, video.meta.avoid_target_top_in_hrefs)"
        class="z-10 no-underline text-text hover:underline hover:text-brand"
        @click.stop
      >
        {{ video.attributes.title }}
      </a>
    </h1>
    <p
      :class="{
        'block-ellip-background': !active,
        'block-ellip-background-dark': active
      }"
      class="text-justify m-0"
    >
      {{ video.attributes.description | stripHtml | ellipsis }}
    </p>
    <span class="text-text-lightest ellip">
      {{ video.attributes.published_at | dateHuge }}
    </span>
  </div>
</template>

<script>
import { Event, Type } from '@/src/server/helpers/constants'

export default {
  props: {
    video: {
      type: Object,
      required: true,
      validator (value) {
        return value.type === Type.VIDEO
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    linkTitle () {
      return this.video.attributes.title + '\n' +
        this.$options.filters.dateTimeHuge(this.video.attributes.published_at)
    },
    thumbnailUrl () {
      return this.video.meta.thumbnail_url || '/static/video-thumbnail.png'
    },
    linkUrl () {
      return this.video.links.domain_url || this.video.links.public_url
    },
  },

  methods: {
    selectVideo () {
      this.$emit(Event.SELECTED, this.video)
    },
  },
}
</script>

<style lang="scss" module>
.grid-layout {
  grid-template-areas:
    "thumbnail  title"
    "thumbnail  description"
    "thumbnail  date";
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr auto;
}

.item-thumbnail {
  grid-area: thumbnail;
}
</style>



// WEBPACK FOOTER //
// src/server/components/Videos/Item.vue